const name = 'credit-card';
const path = '/cartao';

export default [
  // routes
  {
    name: `${name}-proposals`,
    path: `${path}/propostas`,
    component: () => import('@/views/creditCard/List.vue'),
  },
  {
    name: `${name}-simulator`,
    path: `${path}/simular`,
    component: () => import('@/views/creditCard/Simulator.vue'),
  },
  {
    name: `${name}-proposal`,
    path: `${path}/proposta/:proposal_id?`,
    component: () => import('@/views/creditCard/Proposal.vue'),
  },
];
